import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function NewsSubscribe() {
  return (
    <section id="subscribe" className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-10 md:mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                  / Stay Informed
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                Subscribe to TIE Updates
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-white/60 max-w-2xl mx-auto">
                Get the latest research publications, conference announcements, and programme milestones delivered to your inbox.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150}>
            <div className="max-w-xl mx-auto">
              <form
                className="flex flex-col sm:flex-row gap-3"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="flex-1 px-5 py-3.5 rounded-full bg-white/10 border border-white/20 text-white placeholder:text-white/40 text-sm focus:outline-none focus:border-tie-teal-light transition-colors"
                />
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-tie-teal text-white font-medium text-sm hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                  <i className="ri-send-plane-line ml-2" />
                </button>
              </form>
              <p className="mt-4 text-xs text-white/40 text-center">
                No spam. Unsubscribe anytime. We respect your privacy.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={300}>
            <div className="mt-12 md:mt-16 pt-10 md:pt-12 border-t border-white/10">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-white/5 flex items-center justify-center">
                    <i className="ri-book-open-line text-tie-teal-light text-xl" />
                  </div>
                  <h4 className="text-sm font-semibold text-white mb-1">
                    Research Publications
                  </h4>
                  <p className="text-xs text-white/50">
                    New IJTAI issues and PIARC reports
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-white/5 flex items-center justify-center">
                    <i className="ri-mic-line text-tie-teal-light text-xl" />
                  </div>
                  <h4 className="text-sm font-semibold text-white mb-1">
                    Conference Alerts
                  </h4>
                  <p className="text-xs text-white/50">
                    AIRCon calls, deadlines, and programmes
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-white/5 flex items-center justify-center">
                    <i className="ri-flashlight-line text-tie-teal-light text-xl" />
                  </div>
                  <h4 className="text-sm font-semibold text-white mb-1">
                    Programme Milestones
                  </h4>
                  <p className="text-xs text-white/50">
                    PIIC completions, PTIM validations, graduations
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}